import { render, staticRenderFns } from "./MedicineSettingsView.vue?vue&type=template&id=7d627a76"
import script from "./MedicineSettingsView.vue?vue&type=script&lang=js"
export * from "./MedicineSettingsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports